<template>
    <div class="page page-flex bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="con-box">
            <div class="alifont icon-xpsousuo color-999" style="font-size: .4rem"></div>
            <input type="search" class="flex1 input" placeholder="搜索商品">
            <div class="color-main fs-28 click">搜索</div>
        </div>
        <div class="flex1 posi-rel">
            <div class="flex-center product-item click">
                <div class="alifont icon-weixuanzhong color-999" style="font-size: .44rem;"></div>
                <div class="product-img">
                    <img :src="img" alt="">
                </div>
                <div class="flex1">
                    <div class="fs-28 color-333">苹果苹果苹果苹果苹果苹果</div>
                    <div class="mt-10 fs-28"><span class="color-999">价格： </span><span class="color-org">¥234</span></div>
                </div>
            </div>
            <div class="flex-center product-item click">
                <div class="alifont icon-xuanzhong color-main" style="font-size: .44rem;"></div>
                <div class="product-img">
                    <img :src="img" alt="">
                </div>
                <div class="flex1">
                    <div class="fs-28 color-333">苹果苹果苹果苹果苹果苹果</div>
                    <div class="mt-10 fs-28"><span class="color-999">价格： </span><span class="color-org">¥234</span></div>
                </div>
            </div>
            <div class="flex-center product-item click">
                <div class="alifont icon-weixuanzhong color-999" style="font-size: .44rem;"></div>
                <div class="product-img">
                    <img :src="img" alt="">
                </div>
                <div class="flex1">
                    <div class="fs-28 color-333">苹果苹果苹果苹果苹果苹果</div>
                    <div class="mt-10 fs-28"><span class="color-999">价格： </span><span class="color-org">¥234</span></div>
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="">确定换绑</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "exchangeProduct",
        components:{backTitleBar},
        data(){
            return{
                img:require("../../assets/images/shopHome/tag8.png")
            }
        }
    }
</script>

<style scoped lang="scss">
    .con-box{
        margin: .15rem .25rem;
        display: flex;
        align-items: center;
        padding: .16rem .24rem;
        background: #fff;
        border-radius: .12rem;
        .input{
            margin: 0 .1rem;
            border: none;
            outline: none;
            font-size: .28rem;
            line-height: .4rem;
        }
    }
    .product-item{
        padding: .24rem .26rem 0;
        background: #fff;
        margin: 0 .25rem;
        &:first-child{
            border-radius: .12rem .12rem 0 0;
        }
        &:last-child{
            border-radius:  0 0 .12rem .12rem;
            padding-bottom: .24rem;
        }
    }
    .product-img{
        width: 1.22rem;
        height: 1.22rem;
        margin: 0 .12rem 0 .24rem;
    }
</style>



// WEBPACK FOOTER //
// exchangeProduct.vue?38375e7a